import { BookAlert, ChevronRight, Info, ShieldUser } from 'lucide-react';
import UDLink from 'modules/ud-ui/components/link';
import React, { useEffect } from 'react';
import { LANDING_URL, PRIVACY_POLICY_URL, TERMS_AND_CONDITIONS_URL } from 'shared/constants/links';

import UDHeaderTitle from 'ud-ui/components/header-title';
import { useMainLayout } from 'modules/app-shell/ui/layout/context';

const links = [
  {
    href: LANDING_URL,
    label: 'О приложении',
    icon: <Info size={20} />,
  },
  {
    href: PRIVACY_POLICY_URL,
    label: 'Политика конфиденциальности',
    icon: <BookAlert size={20} />,
  },
  {
    href: TERMS_AND_CONDITIONS_URL,
    label: 'Условия использования',
    icon: <ShieldUser size={20} />,
  },
];

const AboutPage: React.FC = () => {
  const { setHeaderContent } = useMainLayout();

  useEffect(() => {
    setHeaderContent(<UDHeaderTitle>О приложении</UDHeaderTitle>);
    return () => setHeaderContent(null);
  }, [setHeaderContent]);

  return (
    <div className="w-full px-6 py-6">
      <div className="flex flex-col gap-3">
        {links.map(({ href, label, icon }) => (
          <UDLink
            key={href}
            to={href}
            target="_blank"
            rel="noreferrer"
            className="dark-blue flex items-center gap-3 rounded-lg bg-white px-5 py-0 no-underline"
            style={{ height: 72, minHeight: 72 }}
          >
            {icon}
            <span className="flex-1">{label}</span>
            <ChevronRight size={20} className="color-gray" style={{ opacity: 0.4 }} />
          </UDLink>
        ))}
      </div>
    </div>
  );
};

export default AboutPage;
